import { apiInstances } from '../../../../libs';

const { get } = apiInstances.authInstance;

export default function verifyToken() {
  return get('/token/verify');
}
